import { useState } from 'react';

import { usePageRequest } from './usePageRequest'
import api from './api'
import { LinkProfile, LinkProfileCreate } from '../models'

export const useLinkProfile = () => {
    const [page, setPage] = useState<number>(1);

    const { data: linkProfiles, loading, refreshAsync: getLinkProfiles } = usePageRequest(
        () => api.get<LinkProfile[]>('v1/link_profile/').then((response) => {
            return response.data
        }),
        {},
        { globalLoading: false }
    )

    const addLinkProfile = (newLinkProfile: LinkProfileCreate) => {
        return api.post('/v1/link_profile/', newLinkProfile)
    }

    return {
        page,
        setPage,
        loading,
        linkProfiles,
        getLinkProfiles,
        addLinkProfile
    }
}